import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../app.state';
import { filter, pluck, map, switchMap, take } from 'rxjs/operators';
import { LoadFriendRequestsAction, AcceptFriendRequestAction, DenyFriendRequestAction } from './friendRequests.actions';
import { FriendRequestsState } from './friendRequests.state';

@Injectable()
export class FriendRequestsStoreDispatcher {
    constructor(private store: Store<AppState>) { }

    public loadFriendRequests() {
        this.store.dispatch(new LoadFriendRequestsAction());
    }

    public acceptFriendRequest(userID) {
        this.store.dispatch(new AcceptFriendRequestAction(userID));
    }

    public denyFriendRequest(userID) {
        this.store.dispatch(new DenyFriendRequestAction(userID));
    }

    /**
     * Get state property functions
     */

    public getState(): Observable<FriendRequestsState> {
        return this.store.select((state: AppState) => state.friendRequests).pipe(filter(friendRequestsState => friendRequestsState != null));
    }

    public getInvitations(): Observable < any[] > {
        return this.getState().pipe(filter(friendRequestsState => friendRequestsState.invitations != null), pluck('invitations'));
    }
}
